import React, { useState, useRef, createRef } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
// import ContentBlock from "../Content/content";
import TextField from "./Inputs/TextField";
import TextArea from "./Inputs/TextArea";
import FileUpload from "./Inputs/FileUpload";
import Recaptcha from "./Inputs/Recaptcha";
import { postFormData } from "./api/Api";
import { ScrollToTop, SendMail, FormValidation, gtmEvent } from "../components/common/utils";
import _ from "lodash";
import "./Form.scss";
import {Link} from "gatsby";
const CareerForm = (props) => {
    const myRef = createRef(null);
    const recaptchaRef = useRef();
    const initFormState = {
        formname: "Career Form",
        fname: '',
        lname: '',
        telephone: '',
        email: '',
        message: '',
        attachment: ''
    }
    const validationFields = ['fname', 'lname', 'email', 'telephone', 'attachment'];
    const [formState, setFormState] = useState(initFormState);
    const [errors, setErrors] = useState({});
    const [errorFlag, setErrorFlag] = useState(false);
    const [showthankyou, setThankyou] = useState(false);
    const [btnProcess, setBtnProcess] = useState(false);

    const handleChange = (e) => {
        setFormState({
            ...formState,
            [e.target.name]: e.target.value
        });
    }
    const handleSubmit = async (event) => {
        event.preventDefault();
        var validation = FormValidation(formState, validationFields);
        // console.log(validation)
        if (validation.status) {
            setErrorFlag(false)
            setErrors(validation.errors)
            const token = await recaptchaRef.current.executeAsync();
            if (token) {
                setBtnProcess(true)
                var postData = _.cloneDeep(formState)
                postData['extra'] = formState;
                let formData = new FormData();
                recaptchaRef.current.reset();
                delete postData['attachment']
                formData.append('data', JSON.stringify(postData));
                if (formState?.attachment) {
                    formData.append('files.attachment', formState.attachment, formState.attachment.name); // appending file
                }
                postFormData(formData).then(async apiRes => {
                    setThankyou(true)
                    setFormState(initFormState)
                    setBtnProcess(false);
                    // scrollTop();
                    myRef?.current?.scrollIntoView({ behavior: 'smooth'})
                    setTimeout(() => {
                        setThankyou(false)
                    }, 9000)
                    if (apiRes?.attachment?.url) {
                        if (apiRes.attachment.url.match(/(http|https):\/\//g)) {
                            postData['cvname'] = `${apiRes.attachment.url}`;
                        } else {
                            postData['cvname'] = `${process.env.GATSBY_STRAPI_FORM_URL}${apiRes.attachment.url}`;
                        }
                    }
                    // GTM tracking event 
                    gtmEvent({ formType: 'Careers - Apply for job', formName: 'Careers Form' })
                    // lets send mail
                    // postData['from_bcc'] = "marketing@strakers.co.uk";
                    // postData['to_bcc'] = "marketing@strakers.co.uk";
                    postData['to_admin'] = "karen.elson@strakers.co.uk";
                    postData['email_temp_user'] = 'career_user';
                    postData['email_temp_admin'] = 'career_admin';
                    postData['email_subject_user'] = 'Strakers - Careers';
                    postData['email_subject_admin'] = 'Strakers - Careers Enquiry';
                    await SendMail(postData);
                });
            }
        } else {
            setErrors(validation.errors)
            setErrorFlag(true)
            // scrollTop();
            myRef?.current?.scrollIntoView({ behavior: 'smooth'})
        }
    }

    const handleAttachment = event => {
        const fileItem = event.target.files[0];
        setFormState({
            ...formState,
            attachment: fileItem
        });
    };

    const scrollTop = () => {
        ScrollToTop(document.getElementById('form-section'), 100)
    }
    const errClass = (field) => {
        if (errors[field]) {
            return 'field-error';
        }
        return ''
    }
    return (
        <React.Fragment>
            <section className='form-section' id="form-section"  ref={myRef}>
            <div className="form form--contact bg-white">
    <div className="form__body">
          <div className="form-row">
                        <Row>
                            <Col md={12}>
                                        {showthankyou && <div className="alert alert-success">
                                            Thank you for your interest. A member of our team will contact you shortly.
                                        </div>}
                                        {
                                            errorFlag &&
                                            <div className="alert alert-danger alert-error">Highlighted fields are required | invalid</div>
                                        }

                                        <div className='form-inputs'>
                                        <Row>
                                            <Col md={6}>
                                            <TextField
                                                label="First Name"
                                                name={`fname`}
                                                placeholder="Enter your first name"
                                                onChange={handleChange}
                                                value={formState[`fname`]}
                                                className={errClass(`fname`)}
                                            />
                                            </Col>
                                            <Col md={6}>
                                            <TextField
                                                label="Last Name"
                                                name={`lname`}
                                                placeholder="Enter your last name"
                                                onChange={handleChange}
                                                value={formState[`lname`]}
                                                className={errClass(`lname`)}
                                            />
                                            </Col>
                                            </Row>
                                            <Row>
                                            <Col md={6}>
                                            <TextField
                                                type="number"
                                                label="Telephone"
                                                name={`telephone`}
                                                placeholder="Enter your telephone number"
                                                onChange={handleChange}
                                                className={errClass(`telephone`)}
                                                value={formState[`telephone`]}
                                            />
                                            </Col>
                                            <Col md={6}>
                                            <TextField
                                                label="Email Address"
                                                name={`email`}
                                                placeholder="Enter your email"
                                                onChange={handleChange}
                                                className={errClass(`email`)}
                                                value={formState[`email`]}
                                            />

                                            </Col>
                                            </Row>
                                            <Row>
                                            <Col md={12}>
                                            <FileUpload
                                                label="Upload CV"
                                                name={`attachment`}
                                                placeholder="Upload CV"
                                                onChange={handleAttachment}
                                                accept=".pdf,.doc"
                                                file={formState.attachment}
                                                className={errClass(`attachment`)}
                                            />
                                            </Col>
                                            </Row>
                                        </div>
                                        <TextArea
                                            label="Message"
                                            rows={5}
                                            name="message"
                                            placeholder="Enter your message"
                                            onChange={handleChange}
                                            value={formState[`message`]}
                                        />
                                        <Recaptcha recaptchaRef={recaptchaRef} />
                                        <div className="form__footer">
                                <button type="submit"
                                    disabled={btnProcess}
                                    onClick={(event) => { handleSubmit(event) }}
                                    className='btn btn--yellow fz14 fw-bolder'
                                >Submit</button>
                                <div className='form-footer-text'>
                                            By clicking Submit, you agree to our <Link to="/terms-and-conditions/">Terms & Conditions</Link> and <Link to="/privacy-policy/">Privacy Policy</Link>.
</div>                                        </div>
                                   
                            </Col>
                        </Row>
                        </div>
                        </div>
                        </div>
            </section>
        </React.Fragment >
    )

}
export default CareerForm;
